import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import ListaCompeticiones from '../views/Competiciones.vue'
import Torneos from '../components/Torneos/Torneos.vue'
import Ligas from '../components/Torneos/Ligas.vue'
import Login from '../components/Login/Login.vue'
import Home from '../components/Home.vue'
import Jugadores from '../components/Gestion/Jugadores/Jugadores.vue'
import Profesores from '../components/Gestion/Profesores/Profesores.vue'
import Canchas from '../components/Gestion/Canchas/Canchas.vue'
import Cronogramas from '../components/Gestion/Cronogramas/Cronogramas.vue'
import Feriados from '../components/Gestion/Cronogramas/Feriados.vue'
import GestionTurnos from '@/components/Turnos/GestionTurnos.vue'
import GestionTurnosSemana from '@/components/Turnos/GestionTurnosSemana.vue'
import GestionTurnosSemanaWide from '@/components/Turnos/GestionTurnosSemanaWide.vue'
import BuscarTurnos from '@/components/Turnos/BuscarTurnos.vue'
import BuscarTurnosEliminados from '@/components/Turnos/BuscarTurnosEliminados.vue'
import Cobros from '@/components/Caja/Cobros.vue'
import CierreCaja from '@/components/Caja/CierreCaja.vue'
import Recordatorios from '@/components/Recordatorios/Recordatorios.vue'
import Usuarios from '@/components/Cuenta/Usuarios.vue'
import ConfCuenta from '@/components/Cuenta/ConfCuenta.vue'
import Dashboard from '@/components/Estadisticas/Dashboard.vue'
import Rankings from '@/components/Rankings/Rankings.vue'
import TiposTurno from '@/components/Configuraciones/TiposTurno.vue'
import Liquidacion from '@/components/Caja/Liquidacion.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
   {
    path: '/',
    name: 'login',
    component: Login
  },
    {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/lista-competiciones',
    name: 'lista-competiciones',
    component: ListaCompeticiones
  },
  {
    path: '/torneos/:idInstitucion/:id',
    name: 'torneos',
    component: Torneos,
    props: true
  },
    {
    path: '/ligas/:idInstitucion/:id',
    name: 'ligas',
    component: Ligas,
    props: true
  },
  {
    path: '/gestion/jugadores',
    name: 'jugadores',
    component: Jugadores,
  },
    {
    path: '/gestion/profesores',
    name: 'profesores',
    component: Profesores,
  },
  {
    path: '/gestion/canchas',
    name: 'canchas',
    component: Canchas,
  },
  {
    path: '/gestion/cronogramas',
    name: 'cronogramas',
    component: Cronogramas,
  },
  {
    path: '/gestion/feriados_y_cancelaciones',
    name: 'feriados',
    component: Feriados,
  },
    {
    path: '/gestion/tipos_turno',
    name: 'tiposTurno',
    component: TiposTurno,
  },
  {
    path: '/turnos/gestion_turnos',
    name: 'gestionTurnos',
    component: GestionTurnos
  },
  {
    path: '/turnos/gestion_turnos_semana',
    name: 'gestionTurnosSemana',
    component: GestionTurnosSemana
  },
  {
    path: '/turnos/gestion_turnos_wide',
    name: 'gestionTurnosSemanaWide',
    component: GestionTurnosSemanaWide
  },
  {
    path: '/turnos/buscar_turnos',
    name: 'buscarTurnos',
    component: BuscarTurnos
  },
  {
    path: '/turnos/buscar_turnos_eliminados',
    name: 'buscarTurnosEliminados',
    component: BuscarTurnosEliminados
  },
  {
    path: '/caja/movimientos',
    name: 'movimientos',
    component: Cobros
  },
    {
    path: '/caja/liquidaciones',
    name: 'liquidaciones',
    component: Liquidacion
  },
  {
    path: '/caja/cierres',
    name: 'cierres',
    component: CierreCaja
  },
  {
    path: '/recordatorios',
    name: 'recordatorios',
    component: Recordatorios
  },
  {
    path: '/cuenta/usuarios',
    name: 'usuarios',
    component: Usuarios
  },
  {
    path: '/cuenta/complejo',
    name: 'complejo',
    component: ConfCuenta
  },
  {
    path: '/estadisticas/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
    {
    path: '/rankings',
    name: 'rankings',
    component: Rankings
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
